import React, { Component } from 'react';
import { MDBCard, MDBCardBody, MDBCardTitle, MDBCardText, MDBIcon, MDBRow, MDBCol, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import axios from 'axios';
import ConfigData from '../Components/config';
import AppDataTable from '../Components/AppDataTable';

export default class AddNumberRobrong extends Component {

    constructor(props) {
        super(props)
        this.state = {
            id_citifacate: null,
            statusno: false,
            NO_TH: null,

            ShowRubrongKru: [],
        }
        this.OpenRpt = this.OpenRpt.bind(this);
        this.edit = this.edit.bind(this);
        this.toggle = this.toggle.bind(this);
        this.handleNoChange = this.handleNoChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        if (!(localStorage.getItem('token'))) {
            window.location.href = '/rubrongkpru'
        }
        axios.get(ConfigData.SERVER_URL + 'FrontEnd_Tabian/payment/ShowRubrongKru/').then((ShowReportPetition) => {
            if (ShowReportPetition.data.length !== 0) {
                var i = 0;
                while (i < ShowReportPetition.data.length) {
                    ShowReportPetition.data[i]['Index'] = i + 1;
                    if (ShowReportPetition.data[i]['NO_TH'] !== null) {
                        ShowReportPetition.data[i]['Statusfill'] = <span>
                            <button className="btn btn-primary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + 1 + "," + ShowReportPetition.data[i].NAME_ENG + "," + ShowReportPetition.data[i].RUBRONG_TYPE} onClick={this.OpenRpt} hidden={ShowReportPetition.data[i].NUM_RUBRONGTH > '0' ? false : true}><MDBIcon icon="print" /> พิมพ์ใบรับรองภาษาไทย</button>
                            <button className="btn btn-secondary btn-sm" value={ShowReportPetition.data[i].ID_NUMBER + "," + 2 + "," + ShowReportPetition.data[i].NAME_ENG + "," + ShowReportPetition.data[i].RUBRONG_TYPE} onClick={this.OpenRpt} hidden={ShowReportPetition.data[i].NUM_RUBRONGEN > '0' ? false : true}><MDBIcon icon="print" /> พิมพ์ใบรับรองอังกฤษ</button>
                        </span>
                    } else {
                        ShowReportPetition.data[i]['Statusfill'] = <span>
                            <button className="btn btn-warning btn-sm" value={ShowReportPetition.data[i].ID_NUMBER} onClick={this.edit}><MDBIcon icon="edit" /> กรอกเลขที่หนังสือ</button>
                        </span>
                    }
                    i++;
                }
                this.setState({
                    ShowRubrongKru: {
                        columns: [
                            { label: '#', field: 'Index', },
                            { label: 'วันที่ร้องขอ', field: 'DATE_INSERT', },
                            { label: 'รหัสนักศึกษา', field: 'OLDID', },
                            { label: 'ชื่อ-นามสกุล', field: 'NAME', },
                            { label: 'ขอใบรับรองเรื่อง', field: 'TYPEPITITION_NAME', },
                            { label: 'ภาษาไทย', field: 'NUM_RUBRONGTH', },
                            { label: 'ภาษาอังกฤษ', field: 'NUM_RUBRONGEN', },
                            { label: 'สถานะ', field: 'Statusfill', },
                        ],
                        rows: ShowReportPetition.data
                    }
                })
            }
        })
    }

    edit(event) {
        // event.preventDefault();
        this.setState({ id_citifacate: event.target.value });
        this.setState({ statusno: true });
    }

    toggle(event) {
        this.setState({ id_citifacate: null });
        this.setState({ statusno: false });
        this.setState({ NO_TH: null });
    }

    OpenRpt(event) {
        var splitvalue = event.target.value.split(",");
        if (splitvalue[1] === "1") {
            if (splitvalue[3] === "32" || splitvalue[3] === "33") {
                window.open(
                    "http://e-certificate.kpru.ac.th/testrubrong.aspx?Id_number=" + splitvalue[0], "_blank"
                );
            }
        } else if (splitvalue[1] === "2") {
            window.open(
                "http://e-certificate.kpru.ac.th/EngCertificate.aspx?Id_number=" + splitvalue[0], "_blank"
            );
        }
    }

    handleNoChange(event) {
        this.setState({ [event.target.name]: event.target.value })
    }

    handleSubmit(event) {
        event.preventDefault();
        let bodydata = {
            NO_TH: this.state.NO_TH,
        }
        axios.post(ConfigData.SERVER_URL + 'FrontEnd_Tabian/payment/UpdateNoRubrongKru/' + this.state.id_citifacate, bodydata).then((data) => {
            if (data.data === 1) {
                this.setState({ id_citifacate: null });
                this.setState({ statusno: false });
                this.setState({ NO_TH: null });
                window.location.reload()
            }
        })
    }

    render() {
        return (<>
            <span className="white-text mt-3" style={{ fontSize: '22px' }}>เลขที่หนังสือใบรับรองครูคืนถิ่น</span><span className="white-text mt-3" style={{ fontSize: '16px' }}> มหาวิทยาลัยราชภัฏกำแพงเพชร</span>

            <MDBRow>
                <MDBCol lg="12" md="12" sm="12">
                    <MDBCard className="mt-3">
                        <MDBCardBody>
                            <MDBCardTitle className="h5">
                                เลขที่หนังสือใบรับรองครูคืนถิ่น
                            </MDBCardTitle>
                            <MDBCardText>
                                <AppDataTable data={this.state.ShowRubrongKru} />
                            </MDBCardText>
                        </MDBCardBody>
                    </MDBCard>
                </MDBCol>
            </MDBRow>

            <MDBModal isOpen={this.state.statusno} toggle={this.toggle} centered>
                <MDBModalHeader toggle={this.toggle}>กรอกเลขที่หนังสือ</MDBModalHeader>
                <form onSubmit={this.handleSubmit}>
                    <MDBModalBody>
                        <div className="form-outline mt-2">
                            <label className="form-label" for="NO_TH">เลขที่หนังสือ เช่น 5222</label>
                            <input type="text" className="form-control" id="NO_TH" name="NO_TH" value={this.state.NO_TH} onChange={this.handleNoChange} required />
                        </div>
                    </MDBModalBody>
                    <MDBModalFooter>
                        <button type="submit" className="btn btn-primary btn-md">บันทึกข้อมูล</button>
                        <button type="button" className="btn btn-danger btn-md" onClick={this.toggle}>ยกเลิก</button>
                    </MDBModalFooter>
                </form>
            </MDBModal>

        </>)
    }
}